

/**
 * Image Lazy loading module
 *
 */

/* eslint-enable */

/**
 *
 * create config object: rootMargin and threshold
 * are two properties exposed by the interface
 */
export const config = {
  rootMargin: '0px 0px 100px 0px',
  threshold: 0,
};

const getObserver = function(config) {
/**
 * This takes the data-src attribute and populates the image src
 *
 * @param {Element} image
 */
  const loadImage = function(image) {
    const source = image.getAttribute('data-src');
    image.src = source;

    image.onload = function() {
      triggerResize();
    };
  };


  /**
 * This forces a resize event on the window
 *
 * resize event helps with spacing issues
 */
  const triggerResize = function() {
    if (navigator.userAgent.indexOf('MSIE') !== -1 ||
    navigator.appVersion.indexOf('Trident/') > 0) {
      const evt = document.createEvent('UIEvents');
      evt.initUIEvent('resize', true, false, window, 0);
      window.dispatchEvent(evt);
    } else {
      window.dispatchEvent(new Event('resize'));
    }
  };

  /**
 *
 * @param {Element} element
 */
  const loadBackground = function(element) {
    const source = element.getAttribute('data-src');
    element.style.backgroundImage = `url('${source}')`;
  };

  /**
 *
 * register the config object with an instance
 * of intersectionObserver
 */

  const observer = new IntersectionObserver(function(entries, self) {
  // iterate over each entry
    entries.forEach(function(entry) {
    // process just the images that are intersecting.
    // isIntersecting is a property exposed by the interface
      if (entry.isIntersecting) {
      // custom function that copies the path to the img
      // from data-src to src
        if (entry.target.tagName === 'IMG') {
          loadImage(entry.target);
        } else if (entry.target.tagName === 'IFRAME') {
          loadImage(entry.target);
        } else {
          loadBackground(entry.target);
        }
        // the image is now in place, stop watching
        self.unobserve(entry.target);
      }
    });
  }, config);

  return observer;
};


/**
   * Initialise the lazy load module
   *
   * @param {string} selector
   */
export default function(selector = '.lazyload[data-src]') {
  if ('IntersectionObserver' in window) {
    const observer = getObserver(config);

    const imgs = document.querySelectorAll(selector);
    imgs.forEach(function(img) {
      observer.observe(img);
    });
  }
}
